import type { DialogService } from '@patsnap/tahiti-core';

export const ConfirmService = Symbol.for('ConfirmService');

/**
 * 确认选项
 */
export interface ConfirmOptions {
    /**
     * 标题
     */
    title?: string;
    /**
     * 取消按钮文本
     */
    cancelText?: string;
    /**
     * 提交按钮文本
     */
    submitText?: string;
    /**
     * 取消按钮样式
     */
    cancelBtnClass?: string;
    /**
     * 提交按钮样式
     */
    submitBtnClass?: string;
}

/**
 * 确认服务
 */
export interface ConfirmService {
    /**
     * 确认
     * @param message 消息
     * @param options 选项
     * @returns 是否确认
     */
    confirm(message: string, options?: ConfirmOptions): Promise<boolean>;
}

export const RequestConfirmDialog = Symbol.for('RequestConfirmDialog');

/**
 * 请求呼出确认对话框
 */
export type RequestConfirmDialog = DialogService<ConfirmOptions & { message: string }, boolean>;
